import {
  queryAddEditSetVariable,
  queryAddNewSetVariable,
  queryDeleteItem,
  queryEditItemSetVariable,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'setVariable',
  state: {
    newSetVariable: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,valueSource,fixedValue,formula,internalField,formFieldValueSource',
    notSelectSearch: 'valueSource,fixedValue,formula,internalField,formFieldValueSource',
    expand: {
      sourceForm: { select: 'name' },
      sourceField: { select: 'displayText' },
      variable: { select: 'internalName' },
      sourceVariable: { select: 'internalName' },
    },
    paramsView: {
      select:
        'id,id,valueSource,fixedValue,formula,internalField,formFieldValueSource,created,updated',
      expand: {
        sourceForm: { select: 'name' },
        sourceField: { select: 'displayText' },
        variable: { select: 'internalName' },
        sourceVariable: { select: 'internalName' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'querySetVariables',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewSetVariable({ payload }, { put }) {
      yield put({
        type: 'addSetVariable',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewSetVariable',
          payload,
        });
      }
    },

    *editItemSetVariable({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemSetVariable, payload);
        yield put({
          type: 'editSetVariable',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewSetVariable({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewSetVariable, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetVariable',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditSetVariable({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditSetVariable, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetVariable',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveSetVariable',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemSetVariable({ view }, { put }) {
      yield put({
        type: 'showEditItemSetVariable',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    querySetVariables(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addSetVariable(state, { payload }) {
      return {
        ...state,
        newSetVariable: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewSetVariable(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editSetVariable(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveSetVariable(state, { payload }) {
      return {
        ...state,
        saveSetVariable: payload,
        newSetVariable: false,
        selectedItem: false,
      };
    },

    showEditItemSetVariable(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newSetVariable: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
